import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CallToActions from "../../../components/common/CallToActions";
import Seo from "../../../components/common/Seo";
import { useRouter } from 'next/router';
import Header11 from "../../../components/header/header-rslhome";
import DefaultFooter from "../../../components/footer/footer-3";
import StepperBooking from "../../../components/booking-page-tour/stepper-booking-holidays";
import { fetchSeoByPage } from "../../../lib/seoHelper";

const Index = ({ meta }) => {
  const router = useRouter();
  const {
    vat
  } = router.query;
  const [click, setClick] = useState(false);
  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    // address1:"",
    // address2:"",
    // state:"",
    countryCode: "",
    // zipcode:"",
    specialRequest: "",
  });

  const { userData } = useSelector((state) => state.user);
  const [searchCountryCodeValue, setSearchCountryCodeValue] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  const handleCurrency = () => {
    setClick((prevState) => !prevState);

    // handleInterval();
    // router.push("/sign-in/sign-in");
    // sessionStorage.setItem('bookingPath', currentPath);
  };
  function handleBooking() {
    if (JSON.parse(sessionStorage.getItem("rslkey")) !== null) {
      // 
    } else {
      handleCurrency();
    }
  }

  useEffect(() => {
    setFormLoading(true);

    // Set a common timeout to stop formLoading after a certain delay (e.g., 2000 milliseconds or 2 seconds)
    const loadingTimeout = setTimeout(() => {
      setFormLoading(false);
    }, 2000); // Adjust the delay as needed (in milliseconds)

    return () => clearTimeout(loadingTimeout);

  }, []);

  useEffect(() => {
    if (userData) {
      if (searchCountryCodeValue === "" && searchCountryCodeValue !== userData.countryCode) {
        setFormLoading(true);
        setValues(userData);
        setSearchCountryCodeValue(userData.countryCode);
      }
      // const timeoutId = setTimeout(() => {
      //   setFormLoading(false);
      // }, 2000);
      // return () => clearTimeout(timeoutId);
    } else {
      setValues({
        name: "",
        email: "",
        phone: "",
        countryCode: "",
        specialRequest: "",
      });
      setFormLoading(false);
    }
  }, [userData]);



  return (
    <>
      <Seo meta={meta} />
      {/* End Page Title */}

      <div className="header-margin"></div>
      {/* header top margin */}

      <Header11 bgColor="#f6f6f6" borderColor="#DFDFDF" />
      {/* End Header 1 */}

      <section className="layout-pb-md">
        <div className="container">
          <h2 className="text-22 fw-500 mt-40 md:mt-24">
            Let us know who you are to proceed with your holiday booking.
          </h2>
          {JSON.parse(sessionStorage.getItem("rslkey")) !== null ? (
            ""
          ) : (
            <div className="ptb-10">
              Do you want to continue as guest or{" "}
              <a href="#" onClick={handleBooking} className="sign-color">
                login
              </a>
              .
            </div>
          )}
          <StepperBooking
            setValues={setValues}
            values={values}
            searchCountryCodeValue={searchCountryCodeValue}
            setSearchCountryCodeValue={setSearchCountryCodeValue}
            setFormLoading={setFormLoading}
            formLoading={formLoading}
            vat={vat}
          />
        </div>
        {/* End container */}
      </section>
      {/* End stepper */}

      <div
        className={`currencyMenu js-currencyMenu ${click ? "" : "is-hidden"}`}
      >
        <div className="currencyMenu__bg" onClick={handleCurrency}></div>
        <div className="currencyMenu__signpop bg-white rounded-4">
          <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
            {/* End Title */}
            <div />

            <button className="pointer" onClick={handleCurrency}>
              <i className="icon-close" />
            </button>
            {/* End colse button */}
          </div>
          {/* End flex wrapper */}
          <div
            className="text-20 fw-500 lh-15 px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: "center",
            }}
          >
            To continue Booking, please sign in to your account
          </div>
          <div
            className="px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: "center",
            }}
          >
            <button
              className="btn bg-dark-3 text-white"
              onClick={() => {
                // router.push("/sign-in/sign-in");
                sessionStorage.setItem("isSig", true);
                setClick(false);
              }}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>

      <CallToActions />
      {/* End Call To Actions Section */}

      <DefaultFooter />
    </>
  );
};

export default Index;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}